module.exports = __webpack_public_path__ + "static/media/boat-img-10.695afc7a.jpg";